import { action, flow, makeObservable, observable } from 'mobx';
import { ApiResponse } from '@roc/client-portal-shared/services';
import { GlobalStore, FormStore } from '@roc/feature-app-core';
import { DialogState } from '@roc/ui';
import { LoanStore } from '@roc/feature-loans';
import { DocumentStore } from '../../documentStore';
import { LoanClosingConditionService } from '../../../services/documentForms/loanClosingConditionServicie';

const REQUIRED_FIELD = 'This field is required.';

const form = {
  fields: {
    level: {
      value: '',
      error: null,
      rule: 'required',
      message: REQUIRED_FIELD,
    },
    description: {
      value: '',
      error: null,
      rule: 'required',
      message: REQUIRED_FIELD,
    },
  },
  meta: {
    isValid: false,
    error: null,
  },
};

export class CreateClosingConditionStore extends FormStore {
  globalStore: GlobalStore;
  loanStore: LoanStore;
  documentStore: DocumentStore;
  dialogState: DialogState = null;
  loanClosingConditionService: LoanClosingConditionService;

  constructor(loanStore: LoanStore, documentStore: DocumentStore, globalStore: GlobalStore) {
    super(form, globalStore);
    this.loanStore = loanStore;
    this.documentStore = documentStore;
    this.globalStore = globalStore;
    this.loanClosingConditionService = new LoanClosingConditionService();

    makeObservable(this, {
      dialogState: observable,
      openEdit: action,
      closeDialog: action,
      resetStore: action,
      submit: flow,
    });
  }

  openEdit() {
    this.resetStore();
    this.dialogState = DialogState.EDIT;
  }

  closeDialog() {
    this.dialogState = null;
  }

  resetStore() {
    this.reset();
  }

  *submit(taskId: number, onSuccess: () => void) {
    try {
      this.runFormValidationWithMessage();
      if (this.form.meta.isValid) {
        const data = {
          ...this.getFormValues(),
        };

        yield this.loanClosingConditionService.addClosingCondition(taskId, data.level, data.description, this.globalStore.isInternalPortal);
        this.globalStore.notificationStore.showSuccessNotification({
          message: `Closing condition saved successfully.`,
        });
        this.resetStore()
        onSuccess()
      }
    } catch {
      this.globalStore.notificationStore.showErrorNotification({
        message: 'Error while saving closing condition',
      });
    }
  }
}
